import { User } from "../../../types/user/user";
import { UserDto } from "../../../types/user/user-dto";
import { convertUserDtoToUser } from "../../../utils/converter/user/user-converter";
import { UserState } from "../../type/user-state";

interface Action {
  type: string;
  payload: {
    userDto: UserDto;
  };
}

export const setUserPageByDtoDispatch = (state: UserState, action: Action) => {
  const { userDto } = action.payload;
  const newUser = convertUserDtoToUser(userDto);

  if (!newUser) {
    return;
  }

  const index = state.userPage.contents.findIndex((user: User) => {
    return user.id === newUser.id;
  });

  if (index !== -1) {
    state.userPage.contents[index] = newUser;
  } else {
    state.userPage = {
      ...state.userPage,
      contents: [newUser, ...state.userPage.contents.slice(0, 9)],
    };
  }
};
